
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"-55 318.2 64 64","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-49.867 318.2h31.445c5.92 0 10.543 1.48 13.78 4.07C-1.035 325.228 1 329.667 1 334.94c0 6.104-2.497 9.989-7.584 12.301v.278c6.659 2.22 10.45 8.139 10.45 15.353 0 6.844-2.589 12.208-6.936 15.445-3.606 2.59-8.416 3.884-14.705 3.884h-32v-64zm28.301 25.064c3.422 0 5.827-1.85 5.827-5.642 0-3.607-2.59-5.456-5.92-5.456h-10.82v11.006h10.912zm1.572 24.786c3.792 0 6.66-2.312 6.66-6.566 0-4.44-3.053-6.567-6.752-6.567H-32.48v13.133z"}})])
          )
        }
      }
    